import { onMounted, onUnmounted, ref, readonly } from "vue";

export function useNow() {
  const now = ref(Date.now());

  let intervalHandle: number;
  onMounted(() => {
    intervalHandle = window.setInterval(() => {
      now.value = Date.now();
    }, 100);
  });

  onUnmounted(() => {
    clearInterval(intervalHandle);
  });

  return readonly(now);
}
